import $ from 'jquery';

$(function () {
  /*
  ///////////////////////////////////////
  template > header.ejs
  ヘッダー
  ///////////////////////////////////////
  */
  $(".l-menu,#l-menu li a").click(function () {
    $(".c-menu1").toggleClass("c-menuclick1");
    $(".c-menu2").toggleClass("c-menuclick2");
    $(".c-menu3").toggleClass("c-menuclick3");
  });

  $('.l-menu,#l-menu li a').click(function () {
    if ($('#l-menu').css('display') == 'none') {
      $('#l-menu').slideDown('fast');
      $("body").on('touchmove.noScroll', function (e) {
        e.preventDefault();
      });
    } else {
      $('#l-menu').slideUp('fast');
      $("body").off('.noScroll');
    }
  });

  /*
  ///////////////////////////////////////
  template > header.ejs
  スムーススクロール
  ///////////////////////////////////////
  */
  $('a[href^="#"]').click(function () {
    var speed = 500;
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top - 120;
    $("html, body").animate({
      scrollTop: position
    }, speed, "swing");
    return false;
  });

  /*
  ///////////////////////////////////////
  index
  フォームバリデーション
  ///////////////////////////////////////
  */
  $(".p-top-form__submitBtn").on("click", function () {
    var tel_val = $('#inquiry_tel').val();
    var tel_result = $.isNumeric(tel_val);
    var address_val = $('#inquiry_address').val();
    var address_result = $.isNumeric(address_val);
    if (tel_result == false) {
      alert('電話番号は半角数値のみを入力して下さい');
      return false;
    } else if (address_result == false) {
      alert('郵便番号は半角数値のみを入力して下さい');
      return false;
    } else if ($('.prefectures-input').val() == "") {
      alert('都道府県を選択して下さい');
      return false;
    } else if ($('.checkbox-input').prop('checked') == false) {
      alert('個人情報の取り扱いについて同意をしてください');
      return false;
    };
  });

});



// WEBPACK FOOTER //
// ./dev/js/app.js